import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { AuthService } from '../authOLD/auth.service';

@Injectable({
  	providedIn: 'root'
})
export class PlatformService {

	constructor(private http: HttpClient, public router: Router, private authSvc: AuthService) { }

	getPlatform(url: string): Observable<boolean> {
		return new Observable<boolean>(observer => {
			const body = {
				"url": url
			}
			const options = {
				headers: new HttpHeaders({
					'Authentication': 'Basic ' + environment.clientSecret,
					'Content-Type': 'application/json; charset=utf-8'
				})
			}

			this.http.post(environment.API_URL + '/clientesolicitante/platform', body, options).subscribe(
				(response: any) => {
					console.log("platform: ", response);
					observer.next(response);
				},
				err => {
					console.log("Error de plataforma: ", err);
					let msgError = "No se ha podido encontrar la plataforma.";

					observer.error(msgError);
				}
			);
		});
	}

	getLogo(name: string, id: number): Observable<boolean> {
		return new Observable<boolean>(observer => {
			const body = {
				"name": name,
				"id": id
			}
			const options = {
				headers: new HttpHeaders({
					'Authentication': 'Basic ' + environment.clientSecret,
					'Content-Type': 'application/json; charset=utf-8'
				})
			}

			this.http.post(environment.API_URL + '/clientesolicitante/logo-platform', body, options).subscribe(
				(response: any) => {
					observer.next(response);
				},
				err => {
					console.log("Error de logo: ", err);
					let msgError = "No se ha podido encontrar el logo.";

					observer.error(msgError);
				}
			);
		});
	}
}
